/**
 * Serviço para consulta de placa via Edge Function no backend.
 */

import { supabase } from "@/integrations/supabase/client"
import { getPlateLookupUserError } from "@/lib/vehicleLookupMessages"

export interface ConsultaPlacaApiResponse {
  error: boolean
  message: string
  response?: Record<string, unknown>
}

export const consultarPlacaApiBrasil = async (placa: string): Promise<ConsultaPlacaApiResponse> => {
  try {
    const { data, error } = await supabase.functions.invoke("consultar-placa", {
      body: { placa },
    })

    if (error) {
      let message = error.message || "Erro ao consultar a placa."
      try {
        const context = (error as { context?: { json?: () => Promise<{ message?: string; error?: string }> } }).context
        const body = await context?.json?.()
        message = body?.message || body?.error || message
      } catch {
        // Mantém a mensagem padrão quando o corpo do erro não está disponível.
      }

      return {
        error: true,
        message: getPlateLookupUserError(message).message,
      }
    }

    return {
      error: Boolean(data?.error),
      message: data?.error ? getPlateLookupUserError(data?.message).message : "",
      response: data?.response,
    }
  } catch (error) {
    return {
      error: true,
      message: getPlateLookupUserError().message,
    }
  }
}
